let Router = function (name, routes) {
  return {
    name,
    routes,
  }
}

export default Router
